import { Pipe, PipeTransform } from '@angular/core'


@Pipe({
  name: 'typeOf',
  pure: true
})
export class TypeOfPipe implements PipeTransform {

  public transform(value: any, type: 'string' | 'number' | 'object' | 'array' | 'boolean'): boolean {
    if (type === 'array') {
      return Array.isArray(value)
    }
    return typeof value === type
  }

}
